import { EvaluationRubric } from '../types';

export enum RubricActionType {
    GET_RUBRICS = 'GET_RUBRICS',
    CREATE_RUBRIC = 'CREATE_RUBRIC',
    UPDATE_RUBRIC = 'UPDATE_RUBRIC',
    DELETE_RUBRIC = 'DELETE_RUBRIC',
    GET_PROJECT_RUBRICS = 'GET_PROJECT_RUBRICS',
}

interface GetRubricsAction {
    type: RubricActionType.GET_RUBRICS;
    payload: Array<EvaluationRubric>;
}

interface GetProjectRubricsAction {
    type: RubricActionType.GET_PROJECT_RUBRICS;
    payload: Array<EvaluationRubric>;
}

interface CreateRubricAction {
    type: RubricActionType.CREATE_RUBRIC;
    payload: EvaluationRubric;
}

interface UpdateRubricAction {
    type: RubricActionType.UPDATE_RUBRIC;
    payload: EvaluationRubric;
}

interface DeleteRubricAction {
    type: RubricActionType.DELETE_RUBRIC;
    payload: EvaluationRubric;
}

export type RubricAction =
    | GetRubricsAction
    | CreateRubricAction
    | UpdateRubricAction
    | DeleteRubricAction
    | GetProjectRubricsAction;
